<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header :title="$t('Details')" class="common-header" ref="header" :style="headerStyle">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>

        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <div class="order-body" v-if="listData && listData.length">

                <div class="list" v-for="item in listData" :key="item.id">
                    <div>
                        <div class="tips-body">
                            <span class="tips">{{ $t('Username') }}: {{ item.member.member_name }}</span>
                            <span class="tips">{{ $t('selling_face_value') }}: {{ item.price }}</span>
                            <span class="tips">{{ $t('Data') }}: {{ item.sale_time }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <empty-record v-else-if="listData && !listData.length"></empty-record>
        </div>

    </div>
</template>

<script>
import { agent_list, agent_gift_list } from '../../../api/memberInviter'
import { Toast, MessageBox, Indicator } from 'mint-ui'
import { mapState } from 'vuex'
import flexLine from '../../flexLine'
import EmptyRecord from '../../../components/EmptyRecord'
export default {
    components: {
        flexLine,
        EmptyRecord,
    },
    computed: {
        ...mapState({
            user: state => state.member.info
        }),
        headerStyle() {
            let newOpacity = Math.min(this.maxOpacity, (this.scrollY - this.startChangeAt) / this.opacityMultiplier);
            if (this.scrollY > this.startChangeAt) {
                return { backgroundColor: `rgba(255, 255, 255, ${newOpacity})` };
            } else {
                return { backgroundColor: 'transparent' };
            }
        }
    },
    data() {
        return {
            weixinVisible: false,
            posterVisible: false,
            shareVisible: false,
            copyVisible: false,
            inviter_url: '',
            time: '',
            refer_qrcode_logo: '',
            refer_qrcode_weixin: '',
            wx_error_msg: '',
            wrapperWidth: 0,
            inviter_member: {},
            scrollY: 0,
            startChangeAt: 20, // 开始改变背景色的滚动阈值
            maxOpacity: 1, // 最大不透明度
            opacityMultiplier: 20, // 滚动距离到最大不透明度的倍数
            other: null,
            listData: null,
            keyword: '', // 关键字
            params: { 'page': 0, 'limit': 10 },
            loading: false, // 是否加载更多
            isMore: true, // 是否有更多
            member_id: this.$route.query.member_id ? this.$route.query.member_id : '',
        }
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        loadMore() {
            this.loading = true
            this.params.page = ++this.params.page
            if (this.isMore) {
                this.loading = false
                this.getOrderList(false)
            }
        },
        handleEnter() {
            // if (!this.keyword) return
            this.getOrderList(true)
        },
        getOrderList(ifReplace) {
            Indicator.open()
            if (ifReplace) {
                this.loading = false
                this.params.page = 1
                this.isMore = true
            }

            agent_gift_list(this.params, this.member_id).then(res => {
                Indicator.close()
                if (res.other.currentPage !== res.other.lastPage) {
                    this.isMore = true
                } else {
                    this.isMore = false
                }

                console.log(this.isMore);
                this.other = res.other
                // this.listData = res.data

                let tOrderGroup = res.data

                if (tOrderGroup) {
                    if (ifReplace || !this.listData) {
                        this.listData = tOrderGroup
                    } else {
                        this.listData = this.listData.concat(tOrderGroup)
                    }
                }
            }).catch(function (error) {
                Indicator.close()
                console.log(error.message)
            })
        },
        handleScroll() {
            this.scrollY = window.pageYOffset || document.documentElement.scrollTop;
        },
        copySuccess(sn) {
            this.$copyText(sn).then(
                (e) => {
                    Toast(this.$t('succ'))
                    this.shareVisible = false
                }, (e) => {
                    Toast(this.$t('err'))
                }
            );
        },
    }
}
</script>

<style scoped lang="scss">
.order-body {
    position: relative;
    padding: .4rem .5rem;

    .list {
        width: 100%;
        padding: .7rem .6rem;
        box-sizing: border-box;
        margin-bottom: 1rem;
        background: #FFFFFF;
        border-radius: 10px 10px 10px 10px;

        .ckxq {
            font-size: 14px;
            color: #CE0901;
            text-align: right;
        }

        .tips-body {
            // height: 2.2rem;
            // background: rgba(255, 255, 255, 1);
            // box-shadow: 0 0.5px 0 0 rgba(232, 234, 237, 1);
            display: flex;
            justify-content: space-between;
            padding: 0 0 .6rem;
            display: grid;
            grid-template-columns: repeat(2, 1fr);

            .tips {
                font-size: .6rem;
                color: #7d7d7d;
                // line-height: 2.2rem;
                font-size: 14px;
                color: #333333;
                margin: 4px;
            }

            .statusTips {
                color: $primaryColor;
            }

            .copy {
                font-weight: 600;
                margin: 0 0;
                font-size: .6rem;
            }

            img {
                width: 3.8rem;
                height: 3rem;
            }
        }

        .order-image {
            // height: 4.55rem;
            // background: rgba(250, 250, 250, 1);
            width: 100%;
            overflow: hidden;
            overflow-x: auto;
            white-space: nowrap;
        }

        .multiple {
            .imagebox {
                width: 100%;
                overflow-x: auto;
                white-space: nowrap;

                img {
                    width: 3rem;
                    height: 3rem;
                    margin: .85rem .3rem .5rem;
                    display: inline-block;
                }
            }
        }

        .number-code {
            font-size: $subFontSize;
            color: rgba(78, 84, 93, 1);
            background-color: #fff;

            .nci {
                height: 2rem;
                padding: 0 .75rem;
                border-bottom: 1px solid #e8eaed;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .tit {
                    margin-bottom: .1rem;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .cc {
                    padding: 0 .1rem;
                }

                .copy {
                    color: $primaryColor;
                    font-weight: 600;
                }
            }
        }

        .order_amount {
            font-size: $subFontSize;
            color: rgba(78, 84, 93, 1);
            // line-height: 2.2rem;
            // height: 2.2rem;
            // background-color: #fff;
            padding: 0 0.5rem;
            // border-bottom: 1px solid #e8eaed;
            box-sizing: border-box;
            text-align: right;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            color: $primaryColor;
            font-weight: 600;

            .order_amount_icon {
                font-size: $subFontSize;
                color: $primaryColor;
            }

            i {
                font-size: $h2;
                color: $primaryColor;
                padding-left: 0.15rem;
                font-style: normal;

                &.freight {
                    color: #333;
                    font-size: $fontSize;
                }
            }
        }
    }

    .loading-wrapper {
        text-align: center;

        p {
            color: #c3c3c3;
            font-size: $fontSize;
            margin: 0.5rem auto;
        }
    }
}

.tit {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .5rem 1rem;

    .l {
        font-size: 18px;
        color: #000000;
        font-weight: 600;
    }

    .r {
        font-size: 14px;
        color: #CE0901;
    }
}

.search {
    margin: .5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    border-radius: 50px 50px 50px 50px;
    margin: .6rem 1rem;
    padding: .4rem 1rem;

    .l {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .icon {
            width: .7rem;
            height: .7rem;
            margin-right: .3rem;

            img {
                width: 100%;
                height: 100%;
                display: block;
            }
        }
    }

    .search1 {
        // background: #fa2a31;
        border-radius: 10px;
        color: #E7010C;
        // padding: 0 10px;
        font-size: .6rem;
        height: 1.6rem;
        line-height: 1.6rem;
        margin-left: 10px;
    }

    input {
        box-sizing: border-box;
        width: 100%;
        height: 1.6rem;
        border-radius: 10px;
        background-size: 0.55rem;
        font-size: 0.6rem;
        color: #000000;
        background: #fff;
        // padding-left: 1.6rem;
        border: 0;
    }
}

.container {
    min-height: 100vh;
    background-color: #F8F8F8;

    .common-header {
        background: transparent;
        box-shadow: none;
    }

    .center {
        padding: 1rem;
        // background: #FFFFFF;
        border-radius: 25px 25px 0 0;

        .huiyuan {
            background: #A62C22;
            border-radius: 5px 5px 5px 5px;
            padding: 1rem;
            display: flex;
            justify-content: space-around;
            align-items: center;

            .hitem {
                text-align: center;
                color: #FFFFFF;

                .k {
                    color: #D39691;
                    font-size: 14px;
                    margin-bottom: .2rem;
                }

                .v {
                    font-size: 33px;
                    font-weight: 600;
                }
            }
        }

        .goto {
            margin: 1rem 0;
            display: flex;
            justify-content: space-around;
            align-items: center;

            .nav-item {
                width: 49%;
                margin-right: 2%;
                background-color: #e7010c;
                font-size: .6rem;
                text-align: center;
                border-radius: .25rem;
                margin-bottom: .5rem;
                padding: 1rem 0;
                font-size: 12px;
                color: #FFFFFF;
            }
        }
    }
}
</style>
